// src/marketing/marketingApi.ts
import { apiClient } from "@maat/api-base";
var marketingApi = {
  /** Active assets for a placement, grouped into slots for the current viewer. */
  getActiveAssets: async (placement) => {
    return apiClient.get("/main/api/marketing/assets/active", { params: { placement } });
  },
  /** Record a VIEWED / DISMISSED / ACTION_CLICKED event for an asset. */
  recordEvent: async (assetId, type, placement) => {
    await apiClient.post(`/main/api/marketing/assets/${assetId}/events`, { type, placement });
  }
};

export {
  marketingApi
};
